import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components'
import { useConfirmation } from 'ui/hooks'

import { api } from '../../../api'
import { ChangeActiveStatusPayload, UsersWebPageUser } from '../../../types'

export const useChangeStatus = (onChanged: (forceToLogout: boolean) => void) => {
  const [userToChangeStatus, setUserToChangeStatus] = useState<UsersWebPageUser | null>(null)
  const active = userToChangeStatus?.active || false
  const name = `${userToChangeStatus?.firstName} ${userToChangeStatus?.lastName}`.trim() || 'this'

  const changeActiveStatus = useMutation<void, Error, ChangeActiveStatusPayload>({
    mutationFn: api.changeActiveStatus,
    onSuccess: async (_, payload) => {
      onChanged(userToChangeStatus !== null && userToChangeStatus.isCurrentUser && !payload.active)
      Toast.success('Success', 'User was saved.')
    },
    onError: (error) => Toast.errorSmall(error.message)
  })

  const { Confirmation: UserStatusConfirmation, open } = useConfirmation({
    message: (
      <span>
        Are you sure you want to {active ? 'deactivate' : 'activate'} <i>{name}</i> user?
      </span>
    ),
    onConfirm: () => {
      if (userToChangeStatus) {
        const { id, active } = userToChangeStatus
        changeActiveStatus.mutateAsync({ id, active: !active })
      }
    },
    confirmationButtonText: active ? 'Deactivate' : 'Activate',
    isConfirmationNegative: !!active
  })

  const onChangeStatus = (user: UsersWebPageUser) => {
    setUserToChangeStatus(user)
    open()
  }

  return {
    onChangeStatus,
    UserStatusConfirmation
  }
}
